import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { generateRandomAlphaNumeric } from "../../../Utils/alphaNumeric";
import { postLogDetails } from "../../../Services/APIs/appDetails";
import pepsodentLogo from "../../../assets/periGum/pepsodent-gum-expert-logo.png"

import pgbsTranslations from "../../PeriGumCheck/Translations/pgbs/l1.json"

const translations = {
    "pgbs": pgbsTranslations,
}

const LandingPage1 = () => {

    const lang = "pgbs"
    localStorage.setItem("userLanguage", lang);
    const navigate = useNavigate()
    const t = translations[lang]
    const storedUid = localStorage.getItem("usertpi")
    const initialId = storedUid ? JSON.parse(storedUid).usertpi : ''
    const [uid, setUid] = useState(initialId)
    const { images } = useSelector((state) => state.fullScan);

    useEffect(() => {
        localStorage.setItem("companyBucket", JSON.stringify({ companyBucket: `pepsodent-gum` }));
        localStorage.setItem("isAutomated", true)
        localStorage.removeItem("scanType");
    }, [lang])

    useEffect(() => {
       
        !localStorage.getItem("reloaded") && reload()
        if (!uid || images.length === 0) {
            generateInfo()
        }
    }, [])

    const reload = () => {
        localStorage.setItem("reloaded", true)
        window.location.reload()
    }

    const generateInfo = () => {
        const randomString = generateRandomAlphaNumeric(2);
        const timestamp = Date.now().toString();
        const randomString2 = generateRandomAlphaNumeric(1)
        const unique = randomString + timestamp + randomString2
        localStorage.setItem("usertpi", JSON.stringify({ usertpi: unique }));
        localStorage.setItem("companyBucket", JSON.stringify({ companyBucket: `pepsodent-gum` }));
        setUid(unique)
        postLogDetails({ uid: unique, app: `pepsodent-gum`, payLoad: `visited landing page 1` })
    }

    const moveToScan = () => {
        localStorage.removeItem("isScanCompleted")
        navigate("/peri-gum/scan")
    }

    const newScan = () => {
        localStorage.clear()
        localStorage.setItem("isAutomated", true)
        localStorage.setItem("reloaded", true)
        generateInfo()
        moveToScan()
    }


    return (
        <div className="h-full w-full bg-gray-50 flex flex-col items-center justify-center p-4 sm:p-6 md:p-12 lg:p-16">
            <img src={pepsodentLogo} alt="pepsodent gum expert logo" className="h-12 sm:h-16 md:h-24 lg:h-32 w-auto object-contain mt-10 sm:mt-12 md:mt-20 lg:mt-24 mb-12 sm:mb-16 md:mb-24 lg:mb-32" />
            <div className="flex-grow flex flex-col items-center justify-center text-center max-w-md px-4 py-8">
                <p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-800 mb-4">
                    {t["header"].split("\n").map((line, index) => (
                        <span key={index}>
                            {line}
                            <br />
                        </span>
                    ))}
                </p>
                {/* <p className="text-base sm:text-lg md:text-2xl lg:text-3xl text-gray-600 mb-8">Get a comprehensive analysis of your gum health with our AI-powered tool.</p> */}
                <button
                    className="bg-pink-500 hover:bg-pink-600 text-white font-bold text-base sm:text-lg md:text-xl py-3 px-8 sm:py-4 sm:px-10 md:py-5 md:px-12 rounded-full shadow-lg transition duration-300 ease-in-out"
                    onClick={moveToScan}
                >
                    {t["callToAction"]}
                </button>
            </div>

        </div>
    );
};

export default LandingPage1;
